module.exports = __webpack_public_path__ + "static/Bg9-b8ab0990050c75832c51a8c30b05d440.png";